// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2tpE3","log":"ModalInventoryLogs_log__FGnWZ","date":"ModalInventoryLogs_date__2cADH","userName":"ModalInventoryLogs_userName__3js40"};